import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import GenericTable from "components/CRPComponents/Tables/GenericTable";
import DefaultCell from "components/CRPComponents/Tables/components/DefaultCell";
import LinkCell from "components/CRPComponents/Tables/components/LinkCell";
import Button from "@mui/material/Button";
import LaunchRoundedIcon from "@mui/icons-material/LaunchRounded";
import { ListProps } from "./types";
import { GET_ALL_QUERY, GetAllGql } from "./queries/getAll";
import { getStatusCell } from "components/CRPComponents/Tables/GenericTable/utils/getStatusCell";
import { canViewEvent, eventViewButtonSx, getEventViewUrl } from "./eventView";

function List(props: ListProps) {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <GenericTable<GetAllGql>
        initialVariables={{
          page: 1,
          perPage: 10,
          search: null,
          status: null,
        }}
        path={`${props.path}/eventos`}
        query={GET_ALL_QUERY}
        useStatusString
        formatRows={(data) =>
          data.Events.items.map((event) => ({
            ...event,
            preview: event.slug,
          }))
        }
        formatPagination={(data) => data.Events.paginationInfo}
        title="NOVO EVENTO"
        columnsTable={[
          {
            Header: "id",
            accessor: "id",
            Cell: ({ value }: any) => (
              <LinkCell href={`${props.path}/eventos/${value}`} value={value} />
            ),
          },
          {
            Header: "Título",
            accessor: "title",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "slug",
            accessor: "slug",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Status",
            accessor: "status",
            Cell: ({ value }: any) => getStatusCell(value),
          },
          {
            Header: "Ver",
            accessor: "preview",
            Cell: ({ row }: any) => {
              const status = row.original.status;
              const slug = row.original.slug;
              const publishOn = row.original.publishOn;
              const disabled = !canViewEvent(status, slug);
              const href = disabled ? undefined : getEventViewUrl(status, slug, publishOn);

              return (
                <Button
                  size="small"
                  variant="outlined"
                  color="info"
                  startIcon={<LaunchRoundedIcon />}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  disabled={disabled}
                  sx={{ ...eventViewButtonSx, minWidth: 88, height: 34 }}
                >
                  Ver
                </Button>
              );
            },
          },
        ]}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default List;
